export default "/images/printer.jpg?68b81c9d235ca06fb0c5c8f08debffb8";